import { render, staticRenderFns } from "./DeclarationSum.vue?vue&type=template&id=0c41e6fc&scoped=true&"
import script from "./DeclarationSum.vue?vue&type=script&lang=js&"
export * from "./DeclarationSum.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationSum.vue?vue&type=style&index=0&id=0c41e6fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c41e6fc",
  null
  
)

export default component.exports